jQuery(function () {
  // -----------------------------------------------------
  // generate article table of content
  // -----------------------------------------------------
  if (jQuery(".main-content.article").length) {
    // if blog article
    jQuery("html").css("scroll-behavior", "smooth");

    index_h2 = 0;
    index_h3 = 0;

    jQuery(".article__content h2").each(function () {
      section_hash = convertToSlug(jQuery(this).text());
      jQuery(this).attr("id", section_hash);

      jQuery("#table-of-content").append(
        "<li>" +
          "<span class='h2-link-number'>#" +
          ++index_h2 +
          "&nbsp;&nbsp;</span>" +
          "<a href=#" +
          section_hash +
          ">" +
          jQuery(this).text() +
          "</a></li>"
      );
    });

    // set ids for faqs
    jQuery(".article__content h3").each(function () {
      section_hash = convertToSlug(jQuery(this).text());
      jQuery(this).attr("id", section_hash);
    });

    // toggle table of content on movile
    if (jQuery(window).width() <= 767) {
      jQuery(".article-sidebar").on("click", function (e) {
        // console.log("READY!!!");
        if (jQuery(this).hasClass("closed")) {
          jQuery("body").css("overflow", "hidden");
          jQuery(this).removeClass("closed").addClass("opened");
        } else {
          jQuery("body").css("overflow", "auto");
          jQuery(this).removeClass("opened").addClass("closed");
        }
      });
    } else {
      jQuery(".article-sidebar").on("click");
    } // if

    // -----------------------------------------------------
    // jcarousel - products on blog article
    // -----------------------------------------------------
    $(document).ready(function () {
      $("#product-article-offers").lightSlider({
        item: 4,
        mode: "slide",

        cssEasing: "ease", //'cubic-bezier(0.25, 0, 0.25, 1)',//
        easing: "linear", //'for jquery animation',////

        speed: 400, //ms'
        loop: true,
        slideEndAnimation: true,
        pause: 2000,

        keyPress: false,
        controls: true,

        adaptiveHeight: true,

        pager: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: "middle",

        enableTouch: true,
        enableDrag: true,
        freeMove: true,
        swipeThreshold: 40,

        responsive: [
          {
            breakpoint: 768,
            settings: {
              item: 4,
              slideMove: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              item: 3,
              slideMove: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              item: 2,
              slideMove: 1,
            },
          },
        ],

        onBeforeStart: function (el) {},
        onSliderLoad: function (el) {
          jQuery("#product-article-offers").css("opacity", "1");
        },
        onBeforeSlide: function (el) {},
        onAfterSlide: function (el) {},
        onBeforeNextSlide: function (el) {},
        onBeforePrevSlide: function (el) {},
      });
    });

    // -----------------------------------------------------
    // get faqs for article body for schema "@type": "FAQPage"
    // -----------------------------------------------------
    article_faqs_questions = [];
    article_faqs_answers = [];

    // $faqs = $("#faqs");
    $faqs = jQuery('[id^="faqs"]');
    $elementsAfterFaqs = $faqs.nextUntil("h2");
    $h3Elements = $elementsAfterFaqs.filter("h3");
    $pElements = $elementsAfterFaqs.filter("p");

    $h3Elements.each(function () {
      article_faqs_questions.push(jQuery(this).text());
    });
    $pElements.each(function () {
      article_faqs_answers.push(jQuery(this).text());
    });

    // jQuery("#faqs")
    //   .next("h3")
    //   .each(function () {
    //     article_faqs_questions.push(jQuery(this).text());
    //   });
    // jQuery("#faqs")
    //   .nextAll("p")
    //   .each(function () {
    //     article_faqs_answers.push(jQuery(this).text());
    //   });

    if (article_faqs_answers.length && article_faqs_questions.length) {
      faqs_schema_part_one =
        "{" +
        '"@context": "http://schema.org",' +
        "\n" +
        '"@type": "FAQPage",' +
        "\n" +
        '"mainEntity": [' +
        "\n";
      faqs_schema_part_two = "";
      for (let i = 0; i < article_faqs_questions.length; i++) {
        faqs_schema_part_two =
          faqs_schema_part_two +
          "{" +
          "\n" +
          '  "@type": "Question",' +
          "\n" +
          '  "name": " ' +
          article_faqs_questions[i] +
          '",' +
          "\n" +
          '  "acceptedAnswer": {' +
          "\n" +
          '    "@type": "Answer",' +
          "\n" +
          '    "text": " ' +
          article_faqs_answers[i] +
          '"' +
          "\n" +
          "  }" +
          "\n";

        if (i === article_faqs_questions.length - 1) {
          faqs_schema_part_two = faqs_schema_part_two + "}" + "\n";
        } else {
          faqs_schema_part_two = faqs_schema_part_two + "}," + "\n";
        }
      }
      faqs_schema_part_three = "]}";
      jQuery("#faq-page-schema").append(
        faqs_schema_part_one + faqs_schema_part_two + faqs_schema_part_three
      );
      console.log("CONTENT:");
      console.log(
        faqs_schema_part_one + faqs_schema_part_two + faqs_schema_part_three
      );
    }
  } // if
});

// --------------------
function convertToSlug(Text) {
  return Text.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}
